import React, { useEffect, useState } from 'react';
import { X, Check } from 'lucide-react';

/**
 * Phase 22 — "Coming Soon" modal with optional notify-me email capture.
 * Pure visual stub — nothing is stored.
 */
export default function ComingSoonModal({ title = 'Coming Soon', body = '', onClose }) {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  // Lock body scroll while open.
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onEsc = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onEsc);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onEsc);
    };
  }, [onClose]);

  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitted(true);
  };

  return (
    <div
      data-testid="coming-soon-modal"
      role="dialog" aria-modal="true"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(10,10,10,0.55)', backdropFilter: 'blur(6px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white', borderRadius: 18, maxWidth: 440, width: '100%',
          padding: 28, boxShadow: '0 30px 80px -20px rgba(0,0,0,0.3)', position: 'relative',
        }}
      >
        <button
          onClick={onClose}
          data-testid="coming-soon-close"
          aria-label="Close"
          style={{
            position: 'absolute', top: 14, right: 14, background: 'transparent', border: 'none',
            cursor: 'pointer', color: '#6B7280', padding: 6, borderRadius: 8,
          }}
        >
          <X size={18} />
        </button>

        <div style={{
          width: 44, height: 44, borderRadius: 12,
          background: 'linear-gradient(135deg, #0FC862 0%, #14F195 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'white', fontWeight: 800, fontSize: 20,
        }}>✦</div>

        <h3 style={{ margin: '18px 0 6px', fontSize: 22, fontWeight: 800, letterSpacing: '-0.02em', color: '#0A0A0A' }}>
          {title}
        </h3>
        {body && <p style={{ color: '#6B7280', margin: 0, fontSize: 15, lineHeight: 1.5 }}>{body}</p>}

        {!submitted ? (
          <form onSubmit={submit} style={{ marginTop: 20, display: 'flex', gap: 8 }}>
            <input
              type="email" required placeholder="Email me when it's ready"
              value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="coming-soon-email"
              style={{
                flex: 1, padding: '11px 13px', borderRadius: 10,
                border: '1px solid #E5E7EB', fontSize: 14, outline: 'none',
              }}
            />
            <button
              type="submit"
              data-testid="coming-soon-notify"
              style={{
                padding: '11px 16px', borderRadius: 10, border: 'none',
                background: '#0FC862', color: 'white', fontWeight: 700, fontSize: 14,
                cursor: 'pointer', boxShadow: '0 8px 20px -8px #0FC862',
              }}
            >
              Notify me
            </button>
          </form>
        ) : (
          <div data-testid="coming-soon-done" style={{
            marginTop: 20, display: 'flex', gap: 10, alignItems: 'center',
            padding: 12, background: '#F0FDF4', border: '1px solid #BBF7D0',
            borderRadius: 10, color: '#166534', fontSize: 14,
          }}>
            <Check size={16} /> You're on the list. We'll email you.
          </div>
        )}
      </div>
    </div>
  );
}
